import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { AiSupportPanelComponent } from './ai-support.panel.component';

angular.module('app-lite.ai-support', [])
  .directive('worAiSupportPanel', downgradeComponent({ component : AiSupportPanelComponent }) as ng.IDirectiveFactory);
